/**
 * Was im Arbeitsspeicher liegen darf (7.69s).
 *
 * Sascha, 10. September: „Also das Anhalten ist nicht schlecht. Aber kann man
 * das nicht irgendwie in den RAM vorladen?“ Genau darauf laufen die Befunde
 * vom iPhone hinaus: siebzehn Haltungen in zehn Sekunden, weil das
 * Videoelement seine Daten stückweise über die Leitung holt -- selbst wenn
 * die Datei längst im Zwischenspeicher der Seite liegt. Liegt sie dagegen als
 * Ganzes im Arbeitsspeicher, gibt es beim Abspielen nichts mehr zu holen.
 *
 * Der Preis ist der Arbeitsspeicher, und den hat ein Telefon nicht in
 * Massen. Deshalb steht die Entscheidung hier und nicht mitten in der
 * Vorschau: Was darf hinein, und was fliegt dafür hinaus?
 *
 * Drei Regeln:
 *
 * 1. **Zu gross ist zu gross.** Eine einzelne Datei über der Grenze kommt
 *    gar nicht erst hinein -- sie würde alles andere verdrängen und wäre
 *    danach das Einzige, was flüssig läuft.
 * 2. **Ältestes zuerst hinaus**, bis der Platz reicht.
 * 3. **Was gerade gebraucht wird, bleibt.** Ein Blob-Verweis, den ein
 *    laufendes Videoelement benutzt, darf nicht weggeworfen werden -- das
 *    Bild bliebe stehen. Reicht der Platz nur, wenn etwas Benutztes weichen
 *    müsste, wird eben nichts geladen.
 */
/** Mehr als das wird je Datei nicht im Arbeitsspeicher gehalten. */
export const RAM_JE_DATEI = 60 * 1024 * 1024;
/** Und mehr als das nicht insgesamt. */
export const RAM_GESAMT = 160 * 1024 * 1024;
export function ramPlan(vorrat, neu, inGebrauch = new Set(), jeDatei = RAM_JE_DATEI, gesamt = RAM_GESAMT) {
    if (vorrat.some((e) => e.schluessel === neu.schluessel))
        return { legen: false, werfen: [], grund: 'schon-da' };
    if (neu.bytes <= 0 || neu.bytes > jeDatei)
        return { legen: false, werfen: [], grund: 'zu-gross' };
    let summe = vorrat.reduce((s, e) => s + e.bytes, 0) + neu.bytes;
    if (summe <= gesamt)
        return { legen: true, werfen: [], grund: 'passt' };
    const werfen = [];
    // Ältestes zuerst -- aber nur, was gerade niemand benutzt.
    for (const e of [...vorrat].sort((a, b) => a.zuletzt - b.zuletzt)) {
        if (summe <= gesamt)
            break;
        if (inGebrauch.has(e.schluessel))
            continue;
        werfen.push(e.schluessel);
        summe -= e.bytes;
    }
    if (summe > gesamt)
        return { legen: false, werfen: [], grund: 'kein-platz' };
    return { legen: true, werfen, grund: 'passt' };
}
//# sourceMappingURL=ram.js.map